var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"version-info",class:{transparent: !_vm.isDev}},[_vm._v("\n  "+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }